import styled, { DefaultTheme } from 'styled-components';

// The dark/normal-mode chrome reads from the theme, but this editor renders in
// contexts without a ThemeProvider (the PunchupEditEvent test harness), so
// resolve each theme colour defensively with a literal fallback — a missing
// theme must not crash the editor.
const c = (theme: DefaultTheme | undefined, key: string, fallback: string): string =>
	(theme?.colors as Record<string, string> | undefined)?.[key] ?? fallback;

const WHITE = '#ffffff';

export const InputContainer = styled.div<{ hasError?: boolean; isPunchup?: boolean }>`
	margin-top: ${({ hasError }) => hasError && '4px'};
	width: 100%;
`;

export const StyledQuillWrapper = styled.div<{ isPunchup?: boolean }>`
	.ql-toolbar {
		border: 1px solid ${({ theme, isPunchup }) => (isPunchup ? '#e5e5e5' : c(theme, 'lightGrey4', '#4b4b4b'))};
		border-bottom: none;
		background: ${({ theme, isPunchup }) => (isPunchup ? WHITE : c(theme, 'blackGrey3', '#2b2b2b'))};
	}

	.ql-toolbar .ql-stroke {
		stroke: ${({ theme, isPunchup }) => (isPunchup ? c(theme, 'grey8', '#4a4a4a') : WHITE)};
	}

	.ql-toolbar .ql-fill {
		fill: ${({ theme, isPunchup }) => (isPunchup ? c(theme, 'grey8', '#4a4a4a') : WHITE)};
	}

	.ql-toolbar button {
		color: ${({ theme, isPunchup }) => (isPunchup ? c(theme, 'grey8', '#4a4a4a') : WHITE)};
	}

	.ql-toolbar button:hover {
		background: ${({ theme, isPunchup }) => (isPunchup ? '#f0f0f0' : c(theme, 'lightGrey4', '#4b4b4b'))};
	}

	.ql-toolbar button.ql-active {
		background: ${({ isPunchup }) => (isPunchup ? '#fe5e25' : '#3b3b3b')};
		color: ${WHITE};
	}

	.ql-toolbar .ql-picker-label {
		color: ${({ theme, isPunchup }) => (isPunchup ? c(theme, 'grey8', '#4a4a4a') : WHITE)};
	}

	.ql-toolbar .ql-picker-options {
		background: ${({ theme, isPunchup }) => (isPunchup ? WHITE : c(theme, 'blackGrey3', '#2b2b2b'))};
		border: 1px solid ${({ theme, isPunchup }) => (isPunchup ? '#e5e5e5' : c(theme, 'lightGrey4', '#4b4b4b'))};
	}

	.ql-toolbar .ql-picker-item {
		color: ${({ theme, isPunchup }) => (isPunchup ? c(theme, 'grey8', '#4a4a4a') : WHITE)};
	}

	.ql-toolbar .ql-picker-item:hover {
		background: ${({ theme, isPunchup }) => (isPunchup ? '#f0f0f0' : c(theme, 'lightGrey4', '#4b4b4b'))};
	}

	.ql-container {
		border: 1px solid ${({ theme, isPunchup }) => (isPunchup ? '#e5e5e5' : c(theme, 'lightGrey4', '#4b4b4b'))};
		background: ${({ theme, isPunchup }) => (isPunchup ? WHITE : c(theme, 'blackGrey3', '#2b2b2b'))};
		color: ${({ theme, isPunchup }) => (isPunchup ? c(theme, 'grey8', '#4a4a4a') : WHITE)};
	}

	.ql-editor {
		color: ${({ theme, isPunchup }) => (isPunchup ? c(theme, 'grey8', '#4a4a4a') : WHITE)};
		min-height: 150px;
	}

	.ql-editor.ql-blank::before {
		color: ${({ theme, isPunchup }) => (isPunchup ? '#999' : c(theme, 'lightGrey2', '#9a9a9a'))};
	}

	.ql-container.ql-snow {
		border: 1px solid ${({ theme, isPunchup }) => (isPunchup ? '#e5e5e5' : c(theme, 'lightGrey4', '#4b4b4b'))};
	}
`;
